/**
 * AppIconsMolecule bond setup
 *
 * Wires @molecule/app-icons-molecule to @molecule/app-icons
 */

import { setIconSet } from '@molecule/app-icons'
import { iconSet } from '@molecule/app-icons-molecule'

import { workspaceIcons } from './workspace-icons.js'

export function setupAppIconsMolecule(): void {
  // Merge the IDE toolbar's extra octicons over the base molecule set (see
  // workspace-icons.ts) so `<Icon name="terminal|database|key|rocket|log" />`
  // resolves without modifying the shared @molecule/app-icons-molecule package.
  setIconSet({ ...iconSet, ...workspaceIcons })
}
